import utils from '../../../modules/utils';
import API from '../../api/api';

function isTokenReceived(status) {
  return status === 'ADYEN_TOKEN_RECEIVED';
}

function isReturningFromHostedPage(queryParams) {
  return !!utils.fn.getURIParam(queryParams, 'paymentMethod');
}

function isProblemWithService(status) {
  return (status === 'ADYEN_AUTHENTICATION_FAILED'
    || status === 'ADYEN_CURRENTLY_UNAVAILABLE'
    || status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams) {
  return API.doAPIRequest(
    '/v2/return-from-hosted/adyen',
    queryParams.substring(1),
    'application/x-www-form-urlencoded; charset=UTF-8',
  );
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
